<template>
  <VModal
      :title="language.id ? 'ویرایش زبان ' : 'ایجاد زبان'"
      :show="show">

    <VAlert class="mt-4" type="danger" v-if="errors.length > 0">
      <div v-for="(error, index) in errors"
           :key="error" :class="{'font-bold' : index === 0}">
        {{ index !== 0 ? '- ' + error : error }}
      </div>
    </VAlert>

    <form @submit.prevent="submit" ref="form">
      <input type="hidden" name="_method" value="PUT" v-if="language.id">

      <div class="mt-5">
        <label>نام</label>
        <VInput type="text" name="name" :value="language.name" placeholder="نام زبان"  class="mt-4" required/>
      </div>

      <div class="mt-5">
        <label>کد</label>
        <VInput type="text" name="code" :value="language.code" placeholder="کد زبان"  class="mt-4" required/>
      </div>

      <div class="flex items-center justify-between mt-8">
        <div>
          <label>وضعیت زبان</label>
          <h6 class="mt-1 text-sm text-muted">در صورت غیرفعال بودن زبان، زبان نمایش داده نمیشود</h6>
        </div>

        <VSwitch v-model="active" :value="language.active"/>
      </div>

      <VButton type="submit" class="mt-10 w-full">ثبت</VButton>

      <VLoadingScreen :show="loading"/>
    </form>

  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";
import VInput from "@/components/General/VInput";
import VSwitch from "@/components/General/VSwitch";
import VButton from "@/components/General/VButton";
import {createLanguage, updateLanguage} from "@/API/API";
import VAlert from "@/components/General/VAlert";
import VLoadingScreen from "@/components/General/VLoadingScreen";

export default {
  name: "ModalLanguage",
  components: {VLoadingScreen, VAlert, VButton, VSwitch, VInput, VModal},
  props: {
    show: Boolean,
    language: {
      default: () => ({})
    }
  },
  data() {
    return {
      active: 1,
      loading: false,
      errors: [],
    }
  },
  methods: {
    submit() {
      this.loading = true
      this.errors = []

      let language = new FormData(this.$refs.form)
      language.append('active', this.active)

      if (this.language.id) {
        this.updateLanguage(language)
      } else {
        this.createLanguage(language)
      }
    },
    updateLanguage(language) {
      updateLanguage(this.language.id, language)
          .then(resp => this.$emit('edited', resp.data))
          .catch(err => this.$helper.validationError(err, this.errors))
          .finally(() => this.loading = false)
    },
    createLanguage(language) {
      createLanguage(language)
          .then(resp => this.$emit('created', resp.data))
          .catch(err => this.$helper.validationError(err, this.errors))
          .finally(() => this.loading = false)
    }
  }

}
</script>

<style scoped>

</style>